import React from 'react';
import { useForm } from '../../hooks/useForm';
import { consent, email, required } from '../../utils/validation';
import { industries } from '../../data/industries';
import { FormField } from '../ui/FormField';
import { ConsentCheckbox } from '../ui/ConsentCheckbox';
import { FormStatus } from '../ui/FormStatus';
import { Button } from '../ui/Button';
type EmployerInquiryFormProps = {
  variant?: 'employer' | 'executive';
  submitLabel?: string;
};
const seniorityOptions = ['Board / Non-Executive', 'C-Suite', 'Executive / Director', 'Senior Management', 'Specialist Professional'];
const timelineOptions = ['As soon as possible', 'Within 1 month', '1–3 months', '3–6 months', 'Exploring options'];
export function EmployerInquiryForm({
  variant = 'employer',
  submitLabel = 'Discuss Your Hiring Needs'
}: EmployerInquiryFormProps) {
  const {
    values,
    errors,
    status,
    setField,
    handleSubmit,
    reset
  } = useForm({
    company: '',
    name: '',
    email: '',
    industry: '',
    role: '',
    seniority: variant === 'executive' ? 'C-Suite' : '',
    location: '',
    timeline: '',
    details: '',
    confidential: variant === 'executive',
    consent: false
  }, {
    company: required('Company name'),
    name: required('Your name'),
    email: email('Business email'),
    industry: required('Industry'),
    role: required('Role or position'),
    seniority: required('Seniority level'),
    timeline: required('Hiring timeline'),
    consent
  });
  return <form noValidate onSubmit={handleSubmit} className="space-y-6" aria-label="Employer inquiry" data-id="element-119" data-mp="232i509qf43en">
      <div className="grid gap-5 sm:grid-cols-2" data-id="element-120" data-mp="1p2qsyejgox3a">
        <FormField name="company" label="Company name" required autoComplete="organization" value={values.company} error={errors.company} onChange={v => setField('company', v)} data-id="element-121" data-mp="1u23gz2m2ka7g" />
        <FormField name="name" label="Contact name" required autoComplete="name" value={values.name} error={errors.name} onChange={v => setField('name', v)} data-id="element-122" data-mp="dqg7kt71s38v" />
        <FormField name="email" label="Business email" type="email" required autoComplete="email" value={values.email} error={errors.email} onChange={v => setField('email', v)} data-id="element-123" data-mp="3upyb7jwqfejv" />
        <FormField name="industry" label="Industry" type="select" required options={industries.map(i => i.name)} value={values.industry} error={errors.industry} onChange={v => setField('industry', v)} data-id="element-124" data-mp="3lx4hihgjgcmh" />
        <FormField name="role" label="Role or position to be filled" required placeholder="e.g. Chief Financial Officer" value={values.role} error={errors.role} onChange={v => setField('role', v)} data-id="element-125" data-mp="3c0rollsti2ss" />
        <FormField name="seniority" label="Seniority level" type="select" required options={seniorityOptions} value={values.seniority} error={errors.seniority} onChange={v => setField('seniority', v)} data-id="element-126" data-mp="330390mnrzuds" />
        <FormField name="location" label="Location" placeholder="City, country or remote" value={values.location} onChange={v => setField('location', v)} data-id="element-127" data-mp="116m1rk3k4vjk" />
        <FormField name="timeline" label="Hiring timeline" type="select" required options={timelineOptions} value={values.timeline} error={errors.timeline} onChange={v => setField('timeline', v)} data-id="element-128" data-mp="13smrt9f6ik5s" />
        <FormField name="details" label="Additional project details" type="textarea" className="sm:col-span-2" placeholder="Context for the role, team, reporting line or anything we should know." value={values.details} onChange={v => setField('details', v)} data-id="element-129" data-mp="1dieoqaar3pdf" />
      </div>
      <div className="space-y-4" data-id="element-130" data-mp="psu7pwy5r26s">
        <ConsentCheckbox name="confidential" checked={values.confidential} onChange={v => setField('confidential', v)} data-id="element-131" data-mp="urooyugh8ios">
          This is a confidential search — please contact me discreetly.
        </ConsentCheckbox>
        <ConsentCheckbox checked={values.consent} error={errors.consent} onChange={v => setField('consent', v)} data-id="element-132" data-mp="267dcpo1k1lqn" />
      </div>
      <FormStatus status={status} onReset={reset} data-id="element-133" data-mp="2a748k65xus21" />
      <Button type="submit" size="lg" variant="navy" arrow className="w-full sm:w-auto" data-id="element-134" data-mp="28r9wiort1z9f">
        {submitLabel}
      </Button>
    </form>;
}